<template>
    <div class="tx-dealersearch module-search-result" :class="{'-clicked': clicked}">
        <div class="result__content result__content--top">
            <div class="content__heading">
                <span class="heading epsilon">{{ result.name }}</span>
            </div>
            <div class="content__categories">
                <div class="categories__category" v-for="(category, index) in result.attributes" :key="'category-' + index">
                    <span>{{ category.title }}</span>
                </div>
            </div>
            <div class="content__contact">
                <div class="contact__address icon-showrooms-before" v-if="result.street || result.zip || result.city">
                    <span class="address__street" v-if="result.street">{{ result.street }}</span>
                    <span class="address__zip" v-if="result.zip">{{ result.zip }}</span>
                    <span class="address__city" v-if="result.city">{{ result.city }}</span>
                </div>
                <div class="contact__phone icon-phone-before" v-if="result.phone">
                    <a :href="`tel:${result.phone}`">{{ result.phone }}</a>
                </div>
                <div class="contact__mail icon-mail-before" v-if="result.email">
                    <a :href="`mailto:${result.email}`"><span v-if="!showEmail">{{ $t('dealersearch.result.email') }}</span><span v-else>{{ result.email }}</span></a>
                </div>
                <div class="content__opening-times icon-clock-before" v-if="result.email && mobile">
                    {{ todaysOpening }}
                </div>
            </div>
        </div>
        <div class="result__content result__content--bottom">
            <div class="content__opening-times icon-clock-before" v-if="!mobile">
                {{ todaysOpening }}
            </div>
            <div class="content__detail">
                <a class="lnk -lnk-alpha icon-arrow-right-before" :href="detailURL(result)"><span>{{ $t('dealersearch.result.moreInfo') }}</span></a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchResult',
  inject: [
    'mobile',
    'phone'
  ],
  data () {
    return {
      showTel: true,
      showEmail: true
    }
  },
  props: {
    result: {
      type: Object,
      default: () => {
      }
    },
    clicked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      detailListingBase: state => state.detailListingBase
    }),
    todaysOpening () {
      const now = new Date()
      const currentDayKey = now.getDay() === 0 ? 7 : now.getDay()
      const currentTime = now.getHours() + now.getMinutes() / 60

      const openingHoursData = this.result.openingHoursCurrent?.items || []

      const getTimeAsFloat = (timeStr) => {
        if (!timeStr || !timeStr.includes(':')) return 0
        const cleanTimeStr = timeStr.trim()
        const [h, m] = cleanTimeStr.split(':')
          .map(Number)
        return h + m / 60
      }

      // openings today
      const today = openingHoursData[currentDayKey]

      // Fall 1: Heute ist geschlossen oder es gibt keine Einträge für heute
      if (!today || today.closed || today.times.length === 0) {
        // Suche nach dem nächsten offenen Tag
        for (let offset = 1; offset <= 7; offset++) {
          const nextDayKey = ((currentDayKey - 1 + offset) % 7) + 1
          const dayInfo = openingHoursData[nextDayKey]
          if (dayInfo && !dayInfo.closed && dayInfo.times.length > 0) {
            const nextTime = dayInfo.times[0].start
            if (offset === 1) {
              return `${this.$t('dealersearch.result.opensTomorrowAt')} ${nextTime.trim()} ${this.$t('dealersearch.result.o_clock')}`
            }
            return this.$t('dealersearch.result.opensOnDayAt', {
              day: dayInfo.label,
              time: nextTime.trim()
            })
          }
        }
        return this.$t('dealersearch.result.noOpeningHours')
      }

      const timeRanges = today.times

      // Prüfen, ob wir uns aktuell in einem offenen Zeitraum befinden
      for (const range of timeRanges) {
        const start = getTimeAsFloat(range.start)
        const end = getTimeAsFloat(range.end)
        if (currentTime >= start && currentTime < end) {
          return `${this.$t('dealersearch.result.openTodayUntil')} ${range.end.trim()} ${this.$t('dealersearch.result.o_clock')}`
        }

        if (currentTime < start) {
          return `${this.$t('dealersearch.result.opensTodayAt')} ${range.start.trim()} ${this.$t('dealersearch.result.o_clock')}`
        }
      }

      // Fall 3: Alle Zeiträume für heute sind bereits vorbei, suche nächsten offenen Tag
      for (let offset = 1; offset <= 7; offset++) {
        const nextDayKey = ((currentDayKey - 1 + offset) % 7) + 1
        const dayInfo = openingHoursData[nextDayKey]
        if (dayInfo && !dayInfo.closed && dayInfo.times.length > 0) {
          const nextTime = dayInfo.times[0].start
          if (offset === 1) {
            return `${this.$t('dealersearch.result.opensTomorrowAt')} ${nextTime.trim()} ${this.$t('dealersearch.result.o_clock')}`
          }
          return this.$t('dealersearch.result.opensOnDayAt', {
            day: dayInfo.label,
            time: nextTime.trim()
          })
        }
      }

      return this.$t('dealersearch.result.noOpeningHours')
    }

  },
  methods: {
    detailURL: function (result) {
      return this.detailListingBase + result.slug
    },
    handleTelLink (event) {
      if (!this.phone) {
        event.preventDefault()
        this.showTel = !this.showTel
      }
    }
  }
}
</script>
